// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-entry-title {
  display: inline-flex;
  align-items: center;
  color: var(--g-color-text-primary);
  overflow: hidden;
  width: 100%;
}
.dl-entry-title_pointer {
  cursor: pointer;
}
.dl-entry-title__icon {
  line-height: 0;
  margin-right: 8px;
}
.dl-entry-title__name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dl-entry-title__date {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--g-color-text-secondary);
  font-family: var(--g-text-caption-font-family);
  font-weight: var(--g-text-caption-font-weight);
  font-size: var(--g-text-caption-2-font-size);
  line-height: var(--g-text-caption-2-line-height);
}
.dl-entry-title__info {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/EntryTitle/EntryTitle.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;EACI,oBAAA;EACA,mBAAA;EACA,kCAAA;EACA,gBAAA;EACA,WAAA;AADJ;AAGI;EACI,eAAA;AADR;AAII;EACI,cAAA;EACA,iBAAA;AAFR;AAKI;ECdA,mBAAA;EACA,gBAAA;EACA,uBAH4B;ADehC;AAII;EClBA,mBAAA;EACA,gBAAA;EACA,uBAH4B;EDqBxB,oCAAA;ECkLJ,8CAAA;EACA,8CAAA;EACA,4CAAA;EACA,gDAAA;ADjLJ;AAAI;ECxBA,mBAAA;EACA,gBAAA;EACA,uBAH4B;AD8BhC","sourcesContent":[".dl-entry-title {\n  display: inline-flex;\n  align-items: center;\n  color: var(--g-color-text-primary);\n  overflow: hidden;\n  width: 100%;\n}\n.dl-entry-title_pointer {\n  cursor: pointer;\n}\n.dl-entry-title__icon {\n  line-height: 0;\n  margin-right: 8px;\n}\n.dl-entry-title__name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dl-entry-title__date {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: var(--g-color-text-secondary);\n  font-family: var(--g-text-caption-font-family);\n  font-weight: var(--g-text-caption-font-weight);\n  font-size: var(--g-text-caption-2-font-size);\n  line-height: var(--g-text-caption-2-line-height);\n}\n.dl-entry-title__info {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
